export default {"src":"/_next/static/media/undo-icon.4d1fa832.svg","height":513,"width":513};